module.exports = __webpack_public_path__ + "03dd82c269f8bd7d68d206263fb777f8.png";